import React, { useEffect, useState } from 'react';
import { useTranslation } from "react-i18next";
import { useNavigate } from "react-router-dom";

const Logout = ({ children }) => {

    const { t } = useTranslation();
    const navigate = useNavigate();
    const [seed, setSeed] = useState(0);
    const [language, setLanguage] = useState('');
    const [logged, setLogged] = useState(false);

    useEffect(() => {
        if (sessionStorage.getItem("currentSession") !== null && sessionStorage.getItem("currentSession")?.bearerToken !== '') {
            sessionStorage.removeItem("currentSession");
            setSeed(Math.random());
            const timeout = setTimeout(() => {
                let redirectUrl = '/';
                window.location.href = redirectUrl;
                navigate(redirectUrl);
            }, 200);
        } else {
            const timeout = setTimeout(() => {
                let redirectUrl = '/';
                window.location.href = redirectUrl;
                navigate(redirectUrl);
            }, 200);
        }
    }, [navigate]);


    return (
        <React.Fragment>
            {children && children}
        </React.Fragment >
    )
};

export default Logout;